module.exports = __webpack_public_path__ + "assets/img/star.f1eb32cb.png";